module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/064-lithuania-49457038e4c1faff983f85f9b7d3ae71.svg";